// Google Apps Script Web App URL for free Google SMTP/Gmail sending
// Replace this placeholder with your actual Google Apps Script Web App URL once deployed
export const GOOGLE_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbzC89X9UfVdzAQc-PY3N8U4dOcW-T6GGZT_zfacFz5YDrXHKYfUFg-m6n29Ed-fphUiAA/exec";
